<div class="modal-header">
    <h4 class="modal-title" [innerHtml]="title"></h4>
</div>
<div class="modal-body">
    <p [innerHtml]="message"></p>
    <div *ngIf="warnings.length > 0">
        <b>Warning</b>
        <ul>
            <li *ngFor="let warning of warnings">{{ warning }}</li>
        </ul>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-info yes-button" (click)="activeModal.close('confirm')">Yes</button>
    <button type="button" class="btn btn-info no-button" (click)="activeModal.dismiss('cancel')">No</button>
</div>